import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css'],
})
export class DeleteModalComponent  implements OnInit {
  @Input() adminDelete: boolean = false;
  @Input() userName: string = '';
  adminDeleteText: string = '';

  constructor() { }

  ngOnInit() {
    if (this.adminDelete) {
     this.adminDeleteText = `The account of @${this.userName} has been deleted.`;
    }
  }

}
